import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteLegalClientFirstHeadMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

interface Args {
  id: string;
  reason: string;
  versionNumber: number;
}

export const useDeleteLegalClientFirstHead = () => {
  const [handle, { loading, error: apolloError }] =
    useDeleteLegalClientFirstHeadMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    deleteLegalClientFirstHead: useCallback(
      async (input: Args) => {
        const res = await handle({ variables: input });
        return res.data?.deleteLegalClientFirstHead;
      },
      [handle]
    ),
  };
};
